module.exports = __webpack_public_path__ + "static/cv-c2cef527222f3757a9d9452937444652.jpg";